import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Status from "../../../../Componets/Status";
import ActionButton from "../../../../Componets/Buttons/action";
import Table from "../../../../Componets/Table";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Employees/Roles/tables";
import headers from "../../../../Data/Tables/Employees/Roles/headers";
import Loadercomponent from "../../../../Componets/Loader";
import { get_all_employee_roles } from "../../../../Controllers/Employees/Roles";

const RolesTable = () => {
  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState();
  const [header, setHeader] = useState(headers);

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const paginationdata = (data) => {
    let headerdata = {};
    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      role: headerdata?.role,
      status: headerdata?.status,
    });
  };

  const formdata = (data) => {
    fetchData(data);
  };

  const actiondata = (data) => {
    fetchData(data);
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const params = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        status: tabledata?.status,
      };

      const roles = await get_all_employee_roles(params);

      if (roles?.status) {
        let data = [];

        roles?.data?.data?.map((value, index) => {
          data?.push({
            Name: value?.name,
            Status: <Status status={value?.status} />,
            Action: (
              <ActionButton
                edit={`/app/employees/roles/edit/${value?._id}`}
                id={value?._id}
                api="delete-employee-role"
                actiondata={actiondata}
              />
            ),
          });
        });

        setPagination({
          currentPage: roles?.data?.currentPage,
          totalCount: roles?.data?.totalCount,
          totalPages: roles?.data?.totalPages,
        });

        setBody(data);
        setLoader(false);
      } else {
        toast?.error(roles?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Table
          head={tables}
          body={body}
          pagination={pagination}
          paginationdata={paginationdata}
        />
      </Loadercomponent>
    </Header>
  );
};

export default RolesTable;
